import React, { useRef, useEffect } from "react";
import "../SimulatorInfo.css";
import SvgLines from "react-mt-svg-lines";

export default function CenterImage({ pageJSON, simPageNum }) {
  const vidRef = useRef();
  useEffect(() => {
    setTimeout(function () {
      if (vidRef.current) {
        vidRef.current.play();
      }
    }, 1000);
  }, [vidRef.current]);
  return (
    <>
      <div
        className="center-image"
        style={{
          top: pageJSON[simPageNum].center_image_data.top,
          left: pageJSON[simPageNum].center_image_data.left,
          height: pageJSON[simPageNum].center_image_data.height,
          width: "auto",
          zIndex: "200",
          transformOrigin: pageJSON[simPageNum].center_image_data
            .transform_origin
            ? pageJSON[simPageNum].center_image_data.transform_origin
            : "center",
        }}
      >
        <img
          alt=""
          src={pageJSON[simPageNum].center_image_data.src}
          style={{
            position: "relative",
            top: pageJSON[simPageNum].center_image_data.top,
            left: pageJSON[simPageNum].center_image_data.left,
            height: pageJSON[simPageNum].center_image_data.height,
            width: "auto",
            zIndex: "200",
          }}
        />
        {pageJSON[simPageNum].center_image_data.black_screen ? (
          <div
            alt="power-off"
            style={{
              backgroundColor: "black",
              position: "relative",
              height: "0px",
              width: "100%",
              paddingBottom: "56.25%",
              zIndex: "300",
            }}
          ></div>
        ) : null}
        {pageJSON[simPageNum].center_image_data.svg ? (
          <>
            <SvgLines animate={1000} stagger={150} duration={3000}>
              <svg
                style={{
                  top: "405px",
                  left: "124px",
                  height: pageJSON[simPageNum].center_image_data.height,
                  width: "auto",
                  transformOrigin: pageJSON[simPageNum].center_image_data
                    .transform_origin
                    ? pageJSON[simPageNum].center_image_data.transform_origin
                    : "center",
                  position: "absolute",
                  zIndex: "200",
                }}
              >
                <path
                  fill="none"
                  stroke="#BF0C3F"
                  stroke-width="4"
                  stroke-miterlimit="10"
                  d="M17.2,199.1v-22.4c0-14.1,11.5-25.6,25.6-25.6h0
	                c14.1,0,25.6,11.5,25.6,25.6v22.4c0,14.1-11.5,25.6-25.6,25.6h0C28.6,224.7,17.2,213.3,17.2,199.1z"
                />
                <path
                  fill="none"
                  stroke="#BF0C3F"
                  stroke-width="4"
                  stroke-miterlimit="10"
                  d="M60.4,160.3L149,14.7h274.4"
                />
                <path
                  fill="none"
                  stroke="#BF0C3F"
                  stroke-width="4"
                  stroke-miterlimit="10"
                  d="M69.7,187.9l96.8-27.6h256.9"
                />
                <circle fill="#BF0C3F" cx="419.5" cy="14.7" r="7.4" />
                <circle fill="#BF0C3F" cx="419.5" cy="160.3" r="7.4" />
              </svg>
            </SvgLines>
            <img
              alt=""
              src="./images/thinq-logo-3.png"
              style={{
                height: "80px",
                width: "auto",
                position: "absolute",
                top: "380px",
                left: "430px",
              }}
            />
            <img
              alt=""
              src="./images/alexa-logo-2.svg"
              style={{
                height: "80px",
                width: "auto",
                position: "absolute",
                top: "525px",
                left: "430px",
              }}
            />
          </>
        ) : null}
        {pageJSON[simPageNum].center_image_data.bezel_screen ? (
          <img
            src={pageJSON[simPageNum].center_image_data.bezel_screen.src}
            alt=""
            style={{
              position: "absolute",
              top: pageJSON[simPageNum].center_image_data.bezel_screen.top,
              left: pageJSON[simPageNum].center_image_data.bezel_screen.left,
              height:
                pageJSON[simPageNum].center_image_data.bezel_screen.height,
              width: pageJSON[simPageNum].center_image_data.bezel_screen.width
                ? pageJSON[simPageNum].center_image_data.bezel_screen.width
                : "auto",
              zIndex: "199",
            }}
          />
        ) : null}

        {pageJSON[simPageNum].center_image_data.bezel_video ? (
          <video
            ref={vidRef}
            src={pageJSON[simPageNum].center_image_data.bezel_video.src}
            alt=""
            style={{
              position: "absolute",
              top: pageJSON[simPageNum].center_image_data.bezel_video.top,
              left: pageJSON[simPageNum].center_image_data.bezel_video.left,
              height: pageJSON[simPageNum].center_image_data.bezel_video.height,
              width: "auto",
              zIndex: "199",
            }}
            // autoPlay
            playsInline
            muted
            loop={false}
          />
        ) : null}
      </div>
    </>
  );
}
